import http from "../http-common";

class PosicionDataService {
  getAll() {
    return http.get("/posicion");
  }

  getCondition(condition) {
    return http.get(`/posicion/search/?desc=${condition}`);
  }

  getPosicionByDescr(condition, sortfield,sorttype,arean2id = null) {
    return http.get(`/posicion/search/?nombreposicion=${condition}&sortfield=${sortfield}&sorttype=${sorttype}&arean2id=${arean2id}`);
  }  

  get(id) {
    return http.get(`/posicion/${id}`);
  }

  create(data) {
    return http.post("/posicion/newposicion", data);
  }

  update(id, data) {
    return http.put(`/posicion/${id}`, data);
  }

  delete(id) {
    return http.delete(`/posicion/${id}`);
  }

  deleteAll() {
    return http.delete(`/arposicionean2`);
  }

  findById(id) {
    return http.get(`/posicion?id=${id}`);
  }
}

export default new PosicionDataService();